import { intersects, select } from "radashi";
import { PropsWithChildren } from "react";
import { FeatureFlag, FeatureFlagsContext } from "./FeatureFlagsContext";

export function FeatureFlagsProvider({
  children,
  flags: propsFlags,
}: PropsWithChildren<{ flags: FeatureFlag[] }>) {
  function isFeatureEnabled(...flags: string[]) {
    const enabledFlags = select(
      propsFlags,
      (flag) => flag.name,
      (flag) => flag.enabled,
    );
    return intersects(flags, enabledFlags);
  }

  return (
    <FeatureFlagsContext.Provider
      value={{ flags: propsFlags, isFeatureEnabled }}
    >
      {children}
    </FeatureFlagsContext.Provider>
  );
}
